import * as types from '../mutation-types'
// import * as constants from "../../mixins/constants"
import {
  getOrderFormPublic,
  createDraftOrderPublic,
  createOrderForm,
  getOrderFormById,
  updateOrderFormById,
  delOrderFormById,
  getListOrderForm,
  createDraftOrder,
  getDraftOrderById,
  updateDraftOrderById,
  delDraftOrderById,
  getListDraftOrder
} from '@/store/api/draft'

const state = {
  order_form_public: {},

  draft_order: {},
  list_draft_order: [],
  order_form: {},
  list_order_form: [],
  error: null
}

const getters = {}

const mutations = {
  [types.GET_DRAFT_ORDER_PUBLIC_SUCCESS](state, { data }) {
    state.order_form_public = data
  },
  [types.DRAFT_ORDER_FAIL](state, { data }) {
    state.error = data
  },
  [types.GET_LIST_ORDER_FORM](state, { data }) {
    state.list_order_form = data
  },
  [types.GET_LIST_DRAFT_ORDER](state, { data }) {
    state.list_draft_order = data
  },
  [types.GET_LIST_DRAFT_ORDER_MORE](state, { data }) {
    state.list_draft_order = [...state.list_draft_order, ...data]
  },
  [types.CREATE_ORDER_FORM](state, { data }) {
    state.list_order_form.push(data)
  },
  [types.EDIT_ORDER_FORM](state, { data }) {
    const index = state.list_order_form.findIndex((e) => e._id === data.id)
    state.list_order_form[index] = { ...data, _id: data.id }
  },
  [types.REMOVE_ORDER_FORM](state, { data }) {
    const index = state.list_order_form.findIndex((e) => e._id === data.id)
    state.list_order_form.splice(index, 1)
  },
  [types.EDIT_DRAFT_ORDER](state, { data }) {
    const index = state.list_draft_order.findIndex((e) => e._id === data.id)
    state.list_draft_order[index] = { ...data, _id: data.id }
  },
  [types.REMOVE_DRAFT_ORDER](state, { data }) {
    const index = state.list_draft_order.findIndex((e) => e._id === data.id)
    state.list_draft_order.splice(index, 1)
  }
}

const actions = {
  getOrderFormPublic({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOrderFormPublic(params)
        .then((response) => {
          if (response.data) {
            commit(types.GET_DRAFT_ORDER_PUBLIC_SUCCESS, { data: response.data })
            resolve(response.data)
            return true
          }
          return false
        })
        .catch((err) => {
          commit(types.DRAFT_ORDER_FAIL, { data: err.response.data })
          reject(err)
          return false
        })
    })
  },
  createDraftOrderPublic({ commit }, params) {
    return new Promise((resolve, reject) => {
      createDraftOrderPublic(params)
        .then((response) => {
          if (response.data && response.status === 200) {
            resolve(response.data)
            return { commit, response }
          }
          return false
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  createOrderForm({ commit }, params) {
    return new Promise((resolve) => {
      createOrderForm(params)
        .then((response) => {
          if (response.data) {
            commit(types.CREATE_ORDER_FORM, { data: response.data })
            resolve(response)
            return true
          }
          return false
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },
  getOrderFormById({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOrderFormById(params)
        .then((response) => {
          resolve(commit, response)
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  updateOrderFormById({ commit }, params) {
    return new Promise((resolve) => {
      updateOrderFormById(params)
        .then((response) => {
          if (response.status === 200) {
            commit(types.EDIT_ORDER_FORM, { data: params })
          }
          resolve(response)
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },
  delOrderFormById({ commit }, params) {
    return new Promise((resolve) => {
      delOrderFormById(params)
        .then((response) => {
          if (response.status === 200) {
            commit(types.REMOVE_ORDER_FORM, { data: params })
          }
          resolve(response)
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },
  getListOrderForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      getListOrderForm(params)
        .then((response) => {
          if (response.data) {
            commit(types.GET_LIST_ORDER_FORM, { data: response.data })
            resolve(response.data)
            return true
          }
          return false
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  createDraftOrder({ commit }, params) {
    return new Promise((resolve) => {
      createDraftOrder(params)
        .then((response) => {
          resolve(response)
          return commit
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },
  getDraftOrderById({ commit }, params) {
    return new Promise((resolve, reject) => {
      getDraftOrderById(params)
        .then((response) => {
          resolve(commit, response)
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  updateDraftOrderById({ commit }, params) {
    return new Promise((resolve) => {
      updateDraftOrderById(params)
        .then((response) => {
          if (response.status === 200) {
            commit(types.EDIT_DRAFT_ORDER, { data: params })
          }
          resolve(response)
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },
  delDraftOrderById({ commit }, params) {
    return new Promise((resolve) => {
      delDraftOrderById(params)
        .then((response) => {
          if (response.status === 200) {
            commit(types.REMOVE_DRAFT_ORDER, { data: params })
            resolve(response)
          }
        })
        .catch((err) => {
          resolve(err.response)
          return false
        })
    })
  },

  getOrderForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOrderFormById(params)
        .then((response) => {
          resolve(commit, response)
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  getListDraftOrder({ commit }, params) {
    if (!params.count) {
      params.count = 10
    }
    if (!params.offset) {
      params.offset = 0
    }
    return new Promise((resolve, reject) => {
      getListDraftOrder(params)
        .then((response) => {
          if (response.data) {
            commit(types.GET_LIST_DRAFT_ORDER, { data: response.data })
            resolve(response.data)
            return true
          }
          return false
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  },
  getListDraftOrderMore({ commit }, params) {
    if (!params.count) {
      params.count = 10
    }
    if (!params.offset) {
      params.offset = 0
    }
    return new Promise((resolve, reject) => {
      getListDraftOrder(params)
        .then((response) => {
          if (response.data) {
            commit(types.GET_LIST_DRAFT_ORDER_MORE, { data: response.data })
            resolve(response.data)
            return true
          }
          return false
        })
        .catch((err) => {
          reject(err)
          return false
        })
    })
  }
}

const draftOrder = {
  state,
  getters,
  mutations,
  actions
}

export default draftOrder
